// extracted by mini-css-extract-plugin
export default {"snakeDot":"Snake_snakeDot__hRGj7"};